// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/** A logger that does nothing when log messages are sent to it. */
var NullLogger =
/** @class */
function () {
  function NullLogger() {}
  /** @inheritDoc */
  // tslint:disable-next-line


  NullLogger.prototype.log = function (_logLevel, _message) {};
  /** The singleton instance of the {@link @aspnet/signalr.NullLogger}. */


  NullLogger.instance = new NullLogger();
  return NullLogger;
}();

export { NullLogger };